import dynamic from 'next/dynamic';

import { ConditionalWrapper } from '@/hoc';

import type { FunctionComponent } from 'react';
import type { TypeFormsTabsProps } from './types';

const Tabs = dynamic(() => import('@/molecules/tabs'), {
  ssr: true,
});

const AlquilerForm = dynamic(() => import('@/molecules/alquiler-form'), {
  ssr: true,
});

const ContactForm = dynamic(() => import('@/molecules/contact-form'), {
  ssr: true,
});

const ReservationForm = dynamic(() => import('@/molecules/reservation-form'), {
  ssr: true,
});

const VisitForm = dynamic(() => import('@/molecules/visit-form'), {
  ssr: true,
});

/**
 * FormsTabs
 */
export const FormsTabs: FunctionComponent<TypeFormsTabsProps> = ({
  flat,
  noTitle,
}: TypeFormsTabsProps) => {
  const visitable = flat.visitable === 'X' && flat.ventaAlquiler !== 'MED_EST';
  const reservable = flat.ventaAlquiler === 'MED_EST';
  const alquilable =
    flat.reservable === 'X' && flat.ventaAlquiler !== 'MED_EST';
  const mediaEstancia = flat.ventaAlquiler === 'MED_EST';

  const tabs = [
    ...(alquilable ? ['Alquiler'] : []),
    ...(visitable ? ['Visita'] : []),
    ...(reservable ? ['Reservar'] : []),
    mediaEstancia ? 'Otra consulta' : 'Otro',
  ];
  const isOnlyContactForm = tabs.length === 1;

  return (
    <>
      {!noTitle && (
        <h4 className="mb-4">
          {isOnlyContactForm ? 'Contacto' : 'Motivo del contacto'}
        </h4>
      )}

      <ConditionalWrapper
        condition={!isOnlyContactForm}
        wrapper={(children) => (
          <Tabs tabs={tabs} unmount>
            {children}
          </Tabs>
        )}
      >
        {alquilable && <AlquilerForm idPiso={flat.codigoUnidadAlquiler} />}

        {visitable && <VisitForm idPiso={flat.codigoUnidadAlquiler} />}

        {reservable && <ReservationForm flat={flat} />}

        <ContactForm flat={flat} />
      </ConditionalWrapper>
    </>
  );
};

FormsTabs.displayName = 'FormsTabs';
